module.exports = __webpack_public_path__ + "assets/no_data.77e67dbf.svg";